import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DataTypes } from '../utility/constants';

@Directive({
  selector: '[appTrimInput]',
  standalone: true,
})
export class TrimInputDirective {
  constructor(readonly control: NgControl) {}

  @HostListener('blur')
  onBlur() {
    const value = this.control.control?.value;
    if (typeof value === DataTypes.String) {
      this.control.control?.setValue(value.trim(), { emitEvent: false });
    }
  }
}
